import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TpETLObjectTypes } from '../../etl-data-types/interfaces';
import { TpETLComponentTypeManifest } from '../interfaces';
import { color } from '../../../visual-analytics/helpers/colors';
import { TpETLPipelineComponent, TpETLDryRun, TpETLDryRunComponentResult } from '../../interfaces';
import { addDryRunObjectText } from '../../utils';
import { CONFIGPARAMTYPES } from '../../../visual-analytics/helpers/configParams';

function performDryRun(dryRun: TpETLDryRun, comp: TpETLPipelineComponent): TpETLDryRunComponentResult {
  addDryRunObjectText(dryRun, comp.outputObjectIds['result'], comp);
  return {
    abort: false,
  };
}

export const manifestETLDefineText: TpETLComponentTypeManifest = {
  id: 'DefineText',
  name: 'Define Text',
  description: 'Defines a fixed piece of text',
  categoryId: 'source',
  color: color(0, 192, 150),
  icon: <FontAwesomeIcon icon={['fas', 'file-lines']} />,
  inputs: [],
  outputs: [
    {
      id: 'result',
      name: 'Output text',
      type: TpETLObjectTypes.TEXT,
    },
  ],
  params: [
    {
      id: 'text',
      name: 'Text',
      paramType: { configParamTypeId: CONFIGPARAMTYPES.Text },
    },
  ],
  performDryRun,
};
